"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn/v1/portal_service.proto (package spwn.spwn.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpwnServicePurchasePawWithMember3DSResponse = exports.SpwnServicePurchasePawWithMember3DSRequest = exports.SpwnServiceCompletePurchasePAWWith3DSResponse = exports.SpwnServiceCompletePurchasePAWWith3DSRequest = exports.SpwnServiceSecureTran2Response = exports.SpwnServiceSecureTran2Request = exports.SpwnServiceUsePawValueResponse = exports.SpwnServiceUsePawValueRequest = exports.ChargeStatus = exports.PurchasePawWithMemberResult = exports.SpwnServicePurchasePawWithMemberResponse = exports.SpwnServicePurchasePawWithMemberRequest = exports.PurchasePawWithCardResult = exports.SpwnServicePurchasePawWithCard3DSResponse = exports.SpwnServicePurchasePawWithCard3DSRequest = exports.SpwnServicePurchasePawWithCardResponse = exports.SpwnServicePurchasePawWithCardRequest = exports.SpwnServiceFetchPawUsageHistoryResponse = exports.SpwnServiceFetchPawUsageHistoryRequest = exports.SpwnServiceFetchPawChargeHistoryResponse = exports.SpwnServiceFetchPawChargeHistoryRequest = exports.SpwnServiceFetchPawBalanceResponse = exports.SpwnServiceFetchPawBalanceRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * PAWの残高を取得する
 *
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawBalanceRequest
 */
class SpwnServiceFetchPawBalanceRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawBalanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawBalanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawBalanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceFetchPawBalanceRequest, a, b);
    }
}
exports.SpwnServiceFetchPawBalanceRequest = SpwnServiceFetchPawBalanceRequest;
SpwnServiceFetchPawBalanceRequest.runtime = protobuf_1.proto3;
SpwnServiceFetchPawBalanceRequest.typeName = "spwn.spwn.v1.SpwnServiceFetchPawBalanceRequest";
SpwnServiceFetchPawBalanceRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawBalanceResponse
 */
class SpwnServiceFetchPawBalanceResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawBalanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawBalanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawBalanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceFetchPawBalanceResponse, a, b);
    }
}
exports.SpwnServiceFetchPawBalanceResponse = SpwnServiceFetchPawBalanceResponse;
SpwnServiceFetchPawBalanceResponse.runtime = protobuf_1.proto3;
SpwnServiceFetchPawBalanceResponse.typeName = "spwn.spwn.v1.SpwnServiceFetchPawBalanceResponse";
SpwnServiceFetchPawBalanceResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: portal_common_pb_1.FetchPawBalance },
]);
/**
 * PAWのチャージ履歴を取得する
 *
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryRequest
 */
class SpwnServiceFetchPawChargeHistoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawChargeHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawChargeHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawChargeHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceFetchPawChargeHistoryRequest, a, b);
    }
}
exports.SpwnServiceFetchPawChargeHistoryRequest = SpwnServiceFetchPawChargeHistoryRequest;
SpwnServiceFetchPawChargeHistoryRequest.runtime = protobuf_1.proto3;
SpwnServiceFetchPawChargeHistoryRequest.typeName = "spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryRequest";
SpwnServiceFetchPawChargeHistoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryResponse
 */
class SpwnServiceFetchPawChargeHistoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.spwn.v1.PawChargeHistory data = 2;
         */
        this.data = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawChargeHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawChargeHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawChargeHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceFetchPawChargeHistoryResponse, a, b);
    }
}
exports.SpwnServiceFetchPawChargeHistoryResponse = SpwnServiceFetchPawChargeHistoryResponse;
SpwnServiceFetchPawChargeHistoryResponse.runtime = protobuf_1.proto3;
SpwnServiceFetchPawChargeHistoryResponse.typeName = "spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryResponse";
SpwnServiceFetchPawChargeHistoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: portal_common_pb_1.PawChargeHistory, repeated: true },
]);
/**
 * PAWの使用履歴を取得する
 *
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryRequest
 */
class SpwnServiceFetchPawUsageHistoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawUsageHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawUsageHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawUsageHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceFetchPawUsageHistoryRequest, a, b);
    }
}
exports.SpwnServiceFetchPawUsageHistoryRequest = SpwnServiceFetchPawUsageHistoryRequest;
SpwnServiceFetchPawUsageHistoryRequest.runtime = protobuf_1.proto3;
SpwnServiceFetchPawUsageHistoryRequest.typeName = "spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryRequest";
SpwnServiceFetchPawUsageHistoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryResponse
 */
class SpwnServiceFetchPawUsageHistoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.spwn.v1.PawUsageHistory data = 2;
         */
        this.data = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawUsageHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawUsageHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawUsageHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceFetchPawUsageHistoryResponse, a, b);
    }
}
exports.SpwnServiceFetchPawUsageHistoryResponse = SpwnServiceFetchPawUsageHistoryResponse;
SpwnServiceFetchPawUsageHistoryResponse.runtime = protobuf_1.proto3;
SpwnServiceFetchPawUsageHistoryResponse.typeName = "spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryResponse";
SpwnServiceFetchPawUsageHistoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: portal_common_pb_1.PawUsageHistory, repeated: true },
]);
/**
 * 新規クレカでのPAW購入
 *
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCardRequest
 */
class SpwnServicePurchasePawWithCardRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * @generated from field: string token = 2;
         */
        this.token = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithCardRequest, a, b);
    }
}
exports.SpwnServicePurchasePawWithCardRequest = SpwnServicePurchasePawWithCardRequest;
SpwnServicePurchasePawWithCardRequest.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithCardRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCardRequest";
SpwnServicePurchasePawWithCardRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCardResponse
 */
class SpwnServicePurchasePawWithCardResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithCardResponse, a, b);
    }
}
exports.SpwnServicePurchasePawWithCardResponse = SpwnServicePurchasePawWithCardResponse;
SpwnServicePurchasePawWithCardResponse.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithCardResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCardResponse";
SpwnServicePurchasePawWithCardResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: PurchasePawWithCardResult },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSRequest
 */
class SpwnServicePurchasePawWithCard3DSRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * @generated from field: string token = 2;
         */
        this.token = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCard3DSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCard3DSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCard3DSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithCard3DSRequest, a, b);
    }
}
exports.SpwnServicePurchasePawWithCard3DSRequest = SpwnServicePurchasePawWithCard3DSRequest;
SpwnServicePurchasePawWithCard3DSRequest.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithCard3DSRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSRequest";
SpwnServicePurchasePawWithCard3DSRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSResponse
 */
class SpwnServicePurchasePawWithCard3DSResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from oneof spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSResponse.data
         */
        this.data = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCard3DSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCard3DSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCard3DSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithCard3DSResponse, a, b);
    }
}
exports.SpwnServicePurchasePawWithCard3DSResponse = SpwnServicePurchasePawWithCard3DSResponse;
SpwnServicePurchasePawWithCard3DSResponse.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithCard3DSResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSResponse";
SpwnServicePurchasePawWithCard3DSResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
    { no: 3, name: "purchase_result", kind: "message", T: PurchasePawWithCardResult, oneof: "data" },
]);
/**
 * @generated from message spwn.spwn.v1.PurchasePawWithCardResult
 */
class PurchasePawWithCardResult extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文ID
         *
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * トランザクションID
         *
         * @generated from field: string transaction_id = 2;
         */
        this.transactionId = "";
        /**
         * チャージされた金額
         *
         * @generated from field: int32 charged_amount = 3;
         */
        this.chargedAmount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PurchasePawWithCardResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchasePawWithCardResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchasePawWithCardResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PurchasePawWithCardResult, a, b);
    }
}
exports.PurchasePawWithCardResult = PurchasePawWithCardResult;
PurchasePawWithCardResult.runtime = protobuf_1.proto3;
PurchasePawWithCardResult.typeName = "spwn.spwn.v1.PurchasePawWithCardResult";
PurchasePawWithCardResult.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "charged_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 既存クレカでのPAW購入
 *
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMemberRequest
 */
class SpwnServicePurchasePawWithMemberRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チャージ金額
         *
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * カード連番 gmoから
         *
         * @generated from field: string card_seq = 2;
         */
        this.cardSeq = "";
        /**
         * カードセキュリティコード
         *
         * @generated from field: string security_code = 3;
         */
        this.securityCode = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithMemberRequest, a, b);
    }
}
exports.SpwnServicePurchasePawWithMemberRequest = SpwnServicePurchasePawWithMemberRequest;
SpwnServicePurchasePawWithMemberRequest.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithMemberRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMemberRequest";
SpwnServicePurchasePawWithMemberRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "card_seq", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "security_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMemberResponse
 */
class SpwnServicePurchasePawWithMemberResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithMemberResponse, a, b);
    }
}
exports.SpwnServicePurchasePawWithMemberResponse = SpwnServicePurchasePawWithMemberResponse;
SpwnServicePurchasePawWithMemberResponse.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithMemberResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMemberResponse";
SpwnServicePurchasePawWithMemberResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: PurchasePawWithMemberResult },
]);
/**
 * @generated from message spwn.spwn.v1.PurchasePawWithMemberResult
 */
class PurchasePawWithMemberResult extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チャージ状態のリスト
         *
         * @generated from field: repeated spwn.spwn.v1.ChargeStatus charges = 1;
         */
        this.charges = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PurchasePawWithMemberResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchasePawWithMemberResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchasePawWithMemberResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PurchasePawWithMemberResult, a, b);
    }
}
exports.PurchasePawWithMemberResult = PurchasePawWithMemberResult;
PurchasePawWithMemberResult.runtime = protobuf_1.proto3;
PurchasePawWithMemberResult.typeName = "spwn.spwn.v1.PurchasePawWithMemberResult";
PurchasePawWithMemberResult.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charges", kind: "message", T: ChargeStatus, repeated: true },
]);
/**
 * @generated from message spwn.spwn.v1.ChargeStatus
 */
class ChargeStatus extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string charge_history_id = 1;
         */
        this.chargeHistoryId = "";
        /**
         * チャージ金額
         *
         * @generated from field: int64 value = 2;
         */
        this.value = protobuf_1.protoInt64.zero;
        /**
         * 使用可能PAW
         *
         * @generated from field: int64 valid_value = 3;
         */
        this.validValue = protobuf_1.protoInt64.zero;
        /**
         * 有効期限
         *
         * @generated from field: int64 expires_at = 4;
         */
        this.expiresAt = protobuf_1.protoInt64.zero;
        /**
         * チャージ日時
         *
         * @generated from field: int64 charged_at = 5;
         */
        this.chargedAt = protobuf_1.protoInt64.zero;
        /**
         * 支払い方法
         *
         * @generated from field: spwn.spwn.v1.PawPaymentMethod payment_method = 6;
         */
        this.paymentMethod = portal_common_pb_1.PawPaymentMethod.UNSPECIFIED;
        /**
         * 支払いステータス
         *
         * @generated from field: spwn.spwn.v1.PawPaymentStatus payment_status = 7;
         */
        this.paymentStatus = portal_common_pb_1.PawPaymentStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChargeStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChargeStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChargeStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ChargeStatus, a, b);
    }
}
exports.ChargeStatus = ChargeStatus;
ChargeStatus.runtime = protobuf_1.proto3;
ChargeStatus.typeName = "spwn.spwn.v1.ChargeStatus";
ChargeStatus.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charge_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "valid_value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "charged_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "payment_method", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.PawPaymentMethod) },
    { no: 7, name: "payment_status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.PawPaymentStatus) },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceUsePawValueRequest
 */
class SpwnServiceUsePawValueRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string item_id = 1;
         */
        this.itemId = "";
        /**
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated string gift_places = 4;
         */
        this.giftPlaces = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceUsePawValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceUsePawValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceUsePawValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceUsePawValueRequest, a, b);
    }
}
exports.SpwnServiceUsePawValueRequest = SpwnServiceUsePawValueRequest;
SpwnServiceUsePawValueRequest.runtime = protobuf_1.proto3;
SpwnServiceUsePawValueRequest.typeName = "spwn.spwn.v1.SpwnServiceUsePawValueRequest";
SpwnServiceUsePawValueRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "firestore_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "gift_places", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceUsePawValueResponse
 */
class SpwnServiceUsePawValueResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceUsePawValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceUsePawValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceUsePawValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceUsePawValueResponse, a, b);
    }
}
exports.SpwnServiceUsePawValueResponse = SpwnServiceUsePawValueResponse;
SpwnServiceUsePawValueResponse.runtime = protobuf_1.proto3;
SpwnServiceUsePawValueResponse.typeName = "spwn.spwn.v1.SpwnServiceUsePawValueResponse";
SpwnServiceUsePawValueResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
]);
/**
 * 3DセキュアのSecureTran2のリクエスト
 *
 * @generated from message spwn.spwn.v1.SpwnServiceSecureTran2Request
 */
class SpwnServiceSecureTran2Request extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string access_id = 1;
         */
        this.accessId = "";
        /**
         * @generated from field: string access_pass = 2;
         */
        this.accessPass = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceSecureTran2Request().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceSecureTran2Request().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceSecureTran2Request().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceSecureTran2Request, a, b);
    }
}
exports.SpwnServiceSecureTran2Request = SpwnServiceSecureTran2Request;
SpwnServiceSecureTran2Request.runtime = protobuf_1.proto3;
SpwnServiceSecureTran2Request.typeName = "spwn.spwn.v1.SpwnServiceSecureTran2Request";
SpwnServiceSecureTran2Request.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "access_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_pass", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 3DセキュアのSecureTran2のレスポンス
 *
 * @generated from message spwn.spwn.v1.SpwnServiceSecureTran2Response
 */
class SpwnServiceSecureTran2Response extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceSecureTran2Response().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceSecureTran2Response().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceSecureTran2Response().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceSecureTran2Response, a, b);
    }
}
exports.SpwnServiceSecureTran2Response = SpwnServiceSecureTran2Response;
SpwnServiceSecureTran2Response.runtime = protobuf_1.proto3;
SpwnServiceSecureTran2Response.typeName = "spwn.spwn.v1.SpwnServiceSecureTran2Response";
SpwnServiceSecureTran2Response.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: portal_common_pb_1.SecureTran2Response },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSRequest
 */
class SpwnServiceCompletePurchasePAWWith3DSRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string access_id = 1;
         */
        this.accessId = "";
        /**
         * @generated from field: string access_pass = 2;
         */
        this.accessPass = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceCompletePurchasePAWWith3DSRequest, a, b);
    }
}
exports.SpwnServiceCompletePurchasePAWWith3DSRequest = SpwnServiceCompletePurchasePAWWith3DSRequest;
SpwnServiceCompletePurchasePAWWith3DSRequest.runtime = protobuf_1.proto3;
SpwnServiceCompletePurchasePAWWith3DSRequest.typeName = "spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSRequest";
SpwnServiceCompletePurchasePAWWith3DSRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "access_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_pass", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSResponse
 */
class SpwnServiceCompletePurchasePAWWith3DSResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServiceCompletePurchasePAWWith3DSResponse, a, b);
    }
}
exports.SpwnServiceCompletePurchasePAWWith3DSResponse = SpwnServiceCompletePurchasePAWWith3DSResponse;
SpwnServiceCompletePurchasePAWWith3DSResponse.runtime = protobuf_1.proto3;
SpwnServiceCompletePurchasePAWWith3DSResponse.typeName = "spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSResponse";
SpwnServiceCompletePurchasePAWWith3DSResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
]);
/**
 * 登録済みクレカでのPAW購入（3Dセキュア2.0対応版）
 *
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSRequest
 */
class SpwnServicePurchasePawWithMember3DSRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チャージ金額
         *
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * カード連番 gmoから
         *
         * @generated from field: string card_seq = 2;
         */
        this.cardSeq = "";
        /**
         * カードセキュリティコード
         *
         * @generated from field: string security_code = 3;
         */
        this.securityCode = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMember3DSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMember3DSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMember3DSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithMember3DSRequest, a, b);
    }
}
exports.SpwnServicePurchasePawWithMember3DSRequest = SpwnServicePurchasePawWithMember3DSRequest;
SpwnServicePurchasePawWithMember3DSRequest.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithMember3DSRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSRequest";
SpwnServicePurchasePawWithMember3DSRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "card_seq", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "security_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSResponse
 */
class SpwnServicePurchasePawWithMember3DSResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = portal_common_pb_1.SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from oneof spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSResponse.data
         */
        this.data = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMember3DSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMember3DSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMember3DSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SpwnServicePurchasePawWithMember3DSResponse, a, b);
    }
}
exports.SpwnServicePurchasePawWithMember3DSResponse = SpwnServicePurchasePawWithMember3DSResponse;
SpwnServicePurchasePawWithMember3DSResponse.runtime = protobuf_1.proto3;
SpwnServicePurchasePawWithMember3DSResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSResponse";
SpwnServicePurchasePawWithMember3DSResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SpwnApiResponse) },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
    { no: 3, name: "purchase_result", kind: "message", T: PurchasePawWithCardResult, oneof: "data" },
]);
//# sourceMappingURL=portal_service_pb.js.map